import { DigitalProductStoreAlertsAlreadyClosed } from './AlreadyClosed'
import { DigitalProductStoreAlertsOpenSoon } from './OpenSoon'

export const DigitalProductStoreAlerts = ({ children }) => {
  return children
}

DigitalProductStoreAlerts.OpenSoon = DigitalProductStoreAlertsOpenSoon
DigitalProductStoreAlerts.AlreadyClosed = DigitalProductStoreAlertsAlreadyClosed
